const svg = function() 
{

	const startClassSVG = function() 
	{

		var $icon = $(this);
		if ($icon.hasClass('svg-inline')) return true;
	
		var bg = $icon.css('background-image').replace('url(', '').replace(')', '').replace(/\"/g, '');
	
		if (bg && bg != 'none') $.get(bg, function (resp) {
			$icon.html($(resp).find('svg')).addClass('svg-inline').trigger('svg-ready');
		});
	
	}
	
	function bgInSvg() 
	{
		$('.svg').each(startClassSVG);
	}

	return {
		init : function() {
			bgInSvg();
		}
	}

}()

module.exports = svg;